import { RectResult } from '../../helpers/useRect';

const OFFSET = 8;

const getPosition = (
  triggerRect: RectResult,
  tooltipRect: RectResult,
  position?: 'top' | 'right' | 'bottom' | 'left',
): Partial<RectResult> => {
  const collisions = {
    top: triggerRect.top - tooltipRect.height < 0,
    right: window.innerWidth < triggerRect.left + tooltipRect.width,
    bottom:
      window.innerHeight < triggerRect.bottom + tooltipRect.height + OFFSET,
    left: triggerRect.left - tooltipRect.width < 0,
  };

  const directionRight = collisions.right && !collisions.left;
  const directionUp = collisions.bottom && !collisions.top;

  if (position === 'right') {
    return {
      left: collisions.right
        ? triggerRect.right -
          triggerRect.width -
          tooltipRect.width -
          OFFSET +
          window.pageXOffset
        : triggerRect.left + triggerRect.width + OFFSET + window.pageXOffset,
      top: directionUp
        ? triggerRect.top - OFFSET - tooltipRect.height + window.pageYOffset
        : triggerRect.top + window.pageYOffset,
    };
  }

  if (position === 'left') {
    return {
      left: collisions.left
        ? triggerRect.left + triggerRect.width + OFFSET + window.pageXOffset
        : triggerRect.right -
          triggerRect.width -
          tooltipRect.width -
          OFFSET +
          window.pageXOffset,
      top: directionUp
        ? triggerRect.top - OFFSET - tooltipRect.height + window.pageYOffset
        : triggerRect.top + window.pageYOffset,
    };
  }

  if (position === 'top') {
    return {
      left: directionRight
        ? triggerRect.right - tooltipRect.width + window.pageXOffset
        : triggerRect.left + window.pageXOffset,
      top: collisions.top
        ? triggerRect.top + OFFSET + triggerRect.height + window.pageYOffset
        : triggerRect.top - OFFSET - tooltipRect.height + window.pageYOffset,
    };
  }

  return {
    left: directionRight
      ? triggerRect.right - tooltipRect.width + window.pageXOffset
      : triggerRect.left + window.pageXOffset,
    top: directionUp
      ? triggerRect.top - OFFSET - tooltipRect.height + window.pageYOffset
      : triggerRect.top + OFFSET + triggerRect.height + window.pageYOffset,
  };
};

export default getPosition;
